import { createSelector } from 'reselect';

const containerSelector = createSelector([
  (store) => store.apps.jobs,
  (store, props) => props.match.params.username,
  (store, props) => props.isOpenSauceUser,
  (store) => store.user,
  (store, props) => props.isSubaccountDashboard,
],
(jobs, username, isOpenSauceUser, user, isSubaccountDashboard) => ({
  filters: jobs.filters,
  filtersInitialized: jobs.filters.get('filtersInitialized'),
  headlessAutomatedLoading: jobs.flatHeadlessJobs.get('headlessAutomatedLoading'),
  isOpenSauceUser: isOpenSauceUser || !user.isAuthenticated(),
  jobsTeamSharingEnabled: jobs.users.get('user').organization.settings ?
    jobs.users.get('user').organization.settings.jobs_cross_team_sharing :
    true,
  jobsTeamSharingFeatureEnabled: !isOpenSauceUser,
  orgTeams: jobs.filters.get('orgTeams'),
  orgUsers: jobs.filters.get('orgUsers'),
  organizationId: jobs.users.get('user').organization.id || user.organization.id,
  shouldFetchOrgUsers: !isOpenSauceUser && !isSubaccountDashboard && user.isAuthenticated(),
  user: jobs.users.get('user'),
  username: username || jobs.users.get('user').username,
}));

const headlessJobsSelector = createSelector([
  (store) => store.apps.jobs,
],
(jobs) => ({
  automated: jobs.flatJobs.get('automated'),
  automatedLoading: jobs.flatJobs.get('automatedLoading'),
}));

export default containerSelector;
export { containerSelector, headlessJobsSelector };
